import Slider from '../components/Slider';
import AboutSection from '../components/AboutSection';
import ServicesSection from '../components/ServicesSection';
import WhatWeDo from '../components/WhatWeDo';
import WorkProcess from '../components/WorkProcess';
import Stats from '../components/Stats';
import Testimonials from '../components/Testimonials';
import Partners from '../components/Partners';
import ContactBanner from '../components/ContactBanner';
import oval from '../media/OvalBig.png';
import bubbles from '../media/burbujas1.png';

// Figuras de fondo. Van fuera del contenedor porque el CSS las posiciona de
// forma absoluta respecto a la página completa.
const decorations = [
  { id: 'oval-slider', className: 'homeOvalSlider', image: oval },
  { id: 'oval-big-about', className: 'homeOvalBigAbout', image: oval },
  { id: 'oval-about', className: 'homeOvalAbout', image: oval },
  { id: 'bubbles-services', className: 'homeBubblesServices', image: bubbles },
  { id: 'bubbles-process', className: 'homeBubblesProcess', image: bubbles },
];

/**
 * Página de inicio: arma la secuencia de secciones del one page.
 */
const Home = () => (
  <>
    <Slider />

    <div className="container">
      <AboutSection />
      <ServicesSection />
      <WhatWeDo />
      <WorkProcess />
      <Stats />
      <Testimonials />
      <Partners />
    </div>

    <ContactBanner />

    {decorations.map(({ id, className, image }) => (
      <div className={className} key={id}>
        <img src={image} alt="" />
      </div>
    ))}
  </>
);

export default Home;
